import { GetChannelConfigFunction } from '@root/libs/init-channel/types';
import { Data as TagData } from '@root/modules/tags/types/tags';
import { mergeAdsPlacements } from '@ads/utils/mergeAdsPlacements';

export default function getTagPageAdsSettings({ $channelConfig, tag }: { $channelConfig: GetChannelConfigFunction; tag: TagData }) {
  const { id } = $channelConfig('settings');
  const { adForm } = $channelConfig('ads').component;

  // Create keywords data
  const keywords = [`${id}`, `temos`, `${tag.slug}`, `tid-${tag.id}`];

  const keyValue = [`www.delfi.lt:${id}`];

  // Get tag page placement overrides
  const { component } = $channelConfig('page').tags;
  const tagsAdsConfig = component?.adForm?.filter((ad) => ad.tags.includes(tag.slug)) || [];
  const channelPlacements: Record<string, unknown> = adForm.placements || {};
  const placements = tagsAdsConfig[0]?.placements ? mergeAdsPlacements(channelPlacements, tagsAdsConfig[0]?.placements) : channelPlacements;
  const disableAds = adForm.disableAds || [];

  return {
    mkw: keywords,
    mkv: keyValue,
    placements,
    disableAds,
  };
}
